module.exports = __webpack_public_path__ + "static/media/  (150).01415a2b.jpg";